import request from "superagent";
import { instanceUrl, site } from "../utils/cms";
import { useState, useEffect } from "react";

/**
 * Loads the site nav.
 */
export default function useNav() {
  var _useState = useState(),
    nav = _useState[0],
    setNav = _useState[1];
  useEffect(function () {
    request.post(instanceUrl() + "WebServices/cms/Page.asmx/GetMenu").send({
      site: site()
    }).set("Accept", "application/json").set("Content-Type", "application/json").end(function (err, response) {
      if (err || !response.ok) {
        setNav([]);
        return;
      }
      response = response.body.d;
      setNav(response.records);
    });
  }, []);
  return nav;
}